// Keeps the footer copyright current; the markup ships a static fallback.
export default function initYear() {
  const el = document.getElementById("current-year");
  if (el) el.textContent = new Date().getFullYear();
}
